import { useEffect, useState } from "react";
import type { SandboxTheme } from "./sandbox/SandboxResumen";

function readDocumentTheme(): SandboxTheme {
  return document.documentElement.getAttribute("data-theme") === "dark" ? "dark" : "light";
}

/** Sigue el tema que fija la página en <html data-theme>. */
export function useDocumentTheme(): SandboxTheme {
  const [theme, setTheme] = useState<SandboxTheme>(readDocumentTheme);
  useEffect(() => {
    const observer = new MutationObserver(() => setTheme(readDocumentTheme()));
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ["data-theme"] });
    setTheme(readDocumentTheme());
    return () => observer.disconnect();
  }, []);
  return theme;
}
